/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вспомогательный класс для отправки в око событий различных элементов из различных вью.
   * @param {object} el Элемент родительской вью
   * @param {object} model модель для отслеживания попадания во вьпорт
   * @param {string} algo параметр передающийся с моделью для отправки в око
   * @param {object} mainWindow нужен ItemInViewPortMixin для отслеживания окна браузера
   * @param {array} okoWatcherObjects Содержит набор объектов:
   * @param {Object} okoWatcherObjects[n].element Класс или Id элемента, на который навешивается слушатель события
   * @param {Object} okoWatcherObjects[n].event Тип события
   * @param {function} okoWatcherObjects[n].data объект или функция собирающая данные для отправки в око
   */
  app.OkoWatcher = app.View.extend({
    additionalOptions: ['okoWatcherObjects', 'algo', 'mainWindow'],
    /**
     * @inheritDoc
     */
    run: function () {
      // включаем бесконечный слушатель вьюпорта
      this.isInfinityListener = true;
      this.updateWatcher();
      this.setViewportData();
    },

    /**
     * Отправить событие во вьпорт, если передана модель
     */
    setViewportData: function() {
      var that = this;
      if (this.model && this.okoWatcherObjects[0].data) {
        this.listenTo(this.model, 'change:is_viewed', function() {
          app.helpers.OkoHelper.push({
            n: app.OKO_N.view,
            algo: that.algo,
          });
        });
      }
    },

    /**
     * Обновляет слушатели всех передаваемых элементов
     * @param {Array} okoWatcherObjects массив с объектами новых классов элементов и событий (если нужно)
     */
    updateWatcher: function (okoWatcherObjects) {
      if (okoWatcherObjects) {
        this.okoWatcherObjects = okoWatcherObjects;
      }
      var delegateObject = {};
      this.okoWatcherObjects.forEach(function(item) {
        delegateObject[item.event + ' ' + item.element] = function(e) {
          app.helpers.OkoHelper.push(item.data(e));
        };
      });
      this.delegateEvents(delegateObject);
      if (this.model && this.model.get('is_viewed')) {
        this.model.unset('is_viewed', {silent: true});
      }
    }
  });
  _.extend(app.OkoWatcher.prototype, app.ItemInViewPortMixin);
})(jQuery);


}.call(window));